/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { labelStyles } from '@zapier/style-encapsulation';
import {
  Colors,
  Icon,
  Typography,
  VisuallyHidden,
} from '@zapier/design-system';

type Props = {
  /*
   * `aria-label` for the `IconButton` if `label` isn't supplied.
   */
  ariaLabel?: string;
  /*
   * `aria-hidden` for the `IconButton`.
   */
  ariaHidden?: boolean;
  /*
   * Indicates whether or not `IconButton` is disabled.
   */
  disabled?: boolean;
  /**
   * `id` of the `input` that this component points to.
   */
  id?: string;
  /**
   * Indicates whether the user is currently searching.
   */
  isSearching: boolean;
  /*
   * Label for the `IconButton`.
   */
  label?: string;

  size?: 'small' | 'medium';
};

const Styles = labelStyles('SearchTogglerInApp', {
  root: css`
    height: 40px;
    border-radius: 40px;
    display: flex;
    align-items: center;
    gap: 5px;
    margin-right: 10px;
    justify-content: center;
    color: ${Colors.neutral800};

    &:hover,
    &:focus {
      background-color: transparent;
      color: ${Colors.neutral800};
      ${Typography.paragraph3Bold};
    }
  `,
});

/**
 * @private
 * Button that controls whether or not the search form is displayed.
 */
const SearchToggler = (props: Props) => {
  return (
    <label css={Styles.root} htmlFor={props.id} data-zds>
      <Icon name={props.isSearching ? 'formX' : 'navSearch'} size={24} />
      {props.size !== 'small' ? (
        'Search'
      ) : (
        <VisuallyHidden>Search</VisuallyHidden>
      )}
    </label>
  );
};

export default SearchToggler;
